import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getPermission(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams); // pathname is "/role"
}

export async function createPermission(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/permission" + pathname, body);
}

export async function bulkCreatePermission(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/permission" + pathname, body);
}

export async function updateDepartments(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/permission" + pathname, body);
}

export async function updatePermission(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).put("/permission" + pathname, body);
}

export async function deletePermission(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).delete("/permission" + pathname, { data: body });
}
